import axios from 'axios';

const model = 'Curso'
const API_URL = process.env.VUE_APP_API_URL;

export default {
  get() {
    return axios.get(`${API_URL}/${model}/v1/list`);
  },

  getCasas() {
  const casas = [
    { Id: 'A', Glosa: 'A' },
    { Id: 'B', Glosa: 'B' },
    { Id: 'C', Glosa: 'C' },
    { Id: 'D', Glosa: 'D' },
    { Id: 'F', Glosa: 'F' },
    { Id: 'G', Glosa: 'G' },
    { Id: 'H', Glosa: 'H' },
    { Id: 'I', Glosa: 'I' },
    { Id: 'J', Glosa: 'J' },
    { Id: 'K', Glosa: 'K' },
    { Id: 'L', Glosa: 'L' },
    { Id: 'M', Glosa: 'M' },
    { Id: 'N', Glosa: 'N' },
    { Id: 'O', Glosa: 'Lancaster' },
    { Id: 'P', Glosa: 'London' },
    { Id: 'Q', Glosa: 'Bristol' },
    { Id: 'R', Glosa: 'Manchester' },
    { Id: 'S', Glosa: 'York' },
    { Id: 'T', Glosa: 'Oxford' }
  ];
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: casas });
      }, 1000);
    });
  },


}